export default __webpack_public_path__ + "static/media/voice.e1b94016.svg";